export const pageThemeToTailwindClasses = (theme: any) => {
    return ["page", "w-full", "min-h-screen", "flex", "flex-col", "items-start", "justify-center", "py-8"];
};
